import { formatDateRaised } from '@/features/jobs/lib/format-date-raised'

export const formatEffectivePeriod = (
  startedAt: string,
  endedAt: string | null
) => {
  const start = formatDateRaised(startedAt)
  const end = endedAt ? formatDateRaised(endedAt) : 'Present'

  return `${start} - ${end}`
}
